<template>
    <b-card class="shadow mb-3 p-2">
        <b-row>
            <b-col>

                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-grow-1"><span class="h2">{{ title }}</span></div>

                    <div class="d-flex flex-grow-1 mb-3">
                        <div class="d-flex justify-content-center flex-grow-0 flex-wrap p-2">
                            <b-form-radio v-model="breakdownType" @change="onBreakdownTypeChange" name="mun-keeping-breakdown-types" value="2" class="mr-4">По видам животных</b-form-radio>
                            <b-form-radio v-if="canSelectShelter()" v-model="breakdownType" @change="onBreakdownTypeChange" name="mun-keeping-breakdown-types" value="3" class="mr-4">По приютам</b-form-radio>
                            <b-form-radio v-if="canSelectCustomer()" v-model="breakdownType" @change="onBreakdownTypeChange" name="mun-keeping-breakdown-types" value="4" class="mr-4">По заказчикам</b-form-radio>
                        </div>
                    </div>

                    <div class="col-xs-12">
                            <transition name="fade" mode="out-in">
                                <div v-if="chartDataInitialized">
                                    <div v-if="chartData.labels.length > 0">
                                        <EventStatisticsPie :chart-data="chartData"  class="mb-3" style="max-width: 100%; height: 400px"/>
                                        <offscreen-chart :title="title">
                                            <template #chart>
                                                <EventStatisticsPie :chart-data="chartData" class="mb-3" style="width: 900px; height: 600px"/>
                                            </template>
                                            <template #subtitle>
                                                <span v-if="breakdownType === '2'">По видам животных</span><span v-if="breakdownType === '3'">По приютам</span><span v-if="breakdownType === '4'">По заказчикам</span>  (на {{ commonQueryParams['date'] }})
                                            </template>
                                        </offscreen-chart>
                                        <StatisticsTable :data="chartData" @on-value-clicked="onTableValueClicked"/>
                                    </div>
                                    <div v-else>
                                        <span class="w-100 text-center">Данных нет</span>
                                        <offscreen-chart :title="title">
                                            <template #context>
                                                <span class="w-100 text-center">Данных нет</span>
                                            </template>
                                            <template #subtitle>
                                                <span v-if="breakdownType === '2'">По видам животных</span><span v-if="breakdownType === '3'">По приютам</span><span v-if="breakdownType === '4'">По заказчикам</span>  (на {{ commonQueryParams['date'] }})
                                            </template>
                                        </offscreen-chart>
                                    </div>
                                </div>
                                <div v-else class="d-flex w-100 align-items-center justify-content-center" style="max-width: 100%; height: 400px">
                                    <b-spinner variant="info"/>
                                </div>
                            </transition>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import EventStatisticsLine from "@/pages/Statistics/EventStatisticsLine";
import {EventStatisticsMixin} from "@/pages/Statistics/eventStatisticsMixin";
import {EventKind} from "@/pages/AppPages/Events/event";
import {mapGetters} from "vuex";
import StatisticsTable from "@/pages/Statistics/StatisticsTable.vue";
import EventStatisticsBar from "@/pages/Statistics/EventStatisticsBar";
import EventStatisticsPie from "@/pages/Statistics/EventStatisticsPie";
import {getPalette} from "@/pages/Statistics/palette";
import OffscreenChart from "@/pages/Statistics/OffscreenChart.vue";
import {TableActions} from "@/store/tables/constants";
import {CONTRACT_TYPE} from "@/pages/AppPages/Catalogs/Contracts/contract";

export default {
    name: "MunicipalKeepingStatistics",
    components: {OffscreenChart, EventStatisticsPie, EventStatisticsBar, StatisticsTable, EventStatisticsLine},
    mixins: [EventStatisticsMixin],
    computed: {
        ...mapGetters(['isMunicipalController', 'isInController', 'isInContractor', 'isVetControl']),
        title() {
            return 'Животные на содержании в муниципальной собственности'
        }
    },
    methods: {
        canSelectShelter() {
            return this.isMunicipalController || this.isInController || this.isVetControl
        },
        canSelectCustomer() {
            return this.isInContractor || (this.isInController && !this.isMunicipalController) || this.isVetControl
        },
        getExtraParams() {
            return [
                { query: { 'mun': 1 }, label: 'Количество животных, находящихся на содержании в муниципальной собственности' },
            ];
        },
        onTableValueClicked(value) {
            const rowParams = value.rowParams;
            const colParams = value.colParams;

            let filters = [
                {'key': 'kind', 'value': EventKind.KEEPING, 'label': 'Содержание'},
                {'key': 'contract_type', 'value': 3, 'label': 'ОМСУ (животные в муниципальной собственности)'},
                {'key': 'execution_date_to', 'value': rowParams['date'], 'label': 'Дата проведения не позднее ' + rowParams['date']},
                {'key': 'is_kept', 'value': true, 'label': 'Находится на содержании'}
            ];

            if (colParams && colParams['animal_species']) {
                filters.push({'key': 'animal_species', 'value': colParams['animal_species'], 'label': colParams['name']})
            }

            if (colParams && colParams['executor']) {
                filters.push({'key': 'executor', 'value': colParams['executor'], 'label': colParams['name']})
            }

            if (colParams && colParams['customer']) {
                filters.push({'key': 'customer', 'value': colParams['customer'], 'label': colParams['name']})
            }

            const tableName = 'common-events-table';
            this.$store.dispatch(TableActions.TABLE_SET_CURRENT_PAGE,
                { name: tableName, page: 1 })
                .then(() => {
                    return this.$store.dispatch(TableActions.TABLE_CHANGE_FILTERS,
                        { name: tableName, filterData: filters })
                })
                .then(() => {
                    window.open('/events', '_blank').focus();
                });
        },
        getBackgroundColors() {
            return getPalette(this.chartData.labels.length)
        }
    },
    beforeMount() {
        this.url = '/statistics/keeping/kept'
        this.breakdownType = 2
    }
}
</script>

<style scoped>

</style>